/* global document */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withContextPath } from '../../components/contextpath';
import InfoModal from '../../components/InfoModal';
import VaccinationToolYellowFeverHandler from './VaccinationToolYellowFeverHandler';

import VaccinationBlock from './VaccinationBlock';

class VaccinationToolResults extends Component {
    static propTypes = {
        contextPath: PropTypes.string,
        countryDetail: PropTypes.shape({
            name: PropTypes.string,
            malaria: PropTypes.string,
            placeholders: PropTypes.object,
            mandatory: PropTypes.Array,
            polioRegulations: PropTypes.string,
            MeniMeningitisRegulations: PropTypes.string,
            allInclusive: PropTypes.Array,
            adventure: PropTypes.Array,
        }),
    };

    static defaultProps = {
        contextPath: '',
        countryDetail: {},
    };

    // That's why the API delivers a complete block as HTML-String
    // we take it, parse and pull the first paragraph. Dirty, I know
    static getFirstMalariaParagraph(htmlString) {
        const template = document.createElement('div');
        template.innerHTML = htmlString.trim();

        try {
            return template.firstChild.innerHTML;
        } catch (e) {
            return htmlString;
        }
    }

    /**
     * Looks in a list of vaccinations for the yellow fever disease
     * @param {Array} vaccinations List of vaccinations
     */
    static findVaccinationsForYellowFever(vaccinations) {
        if (!vaccinations) return false;

        const yellowFeverUid = '1f442dceebcf6e95489174cd469b9fb6';
        return vaccinations.find(vaccination => vaccination.uid === yellowFeverUid);
    }

    /**
     * Looks in a list of vaccinations for Polio
     * @param {Array} vaccinations List of vaccinations
     */
    static findVaccinationsForPolio(vaccinations) {
        if (!vaccinations) return false;

        const PolioUid = '99d4d507698e5c407ba259bed1bc0477';
        return vaccinations.find(vaccination => vaccination.uid === PolioUid);
    }


    /**
     * Looks in a list of vaccinations for Meningokokken-Meningitis
     * @param {Array} vaccinations List of vaccinations
     */
    static findVaccinationsForMeniMeningitis(vaccinations) {
        if (!vaccinations) return false;

        const MeniMeningitisUid = '5699185b9643b33d09dd3e696dc0a491';
        return vaccinations.find(vaccination => vaccination.uid === MeniMeningitisUid);
    }

    /**
     * Returns type of vaccination
     * null = not mandatory
     * C = conditionally mandatory
     * Y = always mandatory
     * @param {Object} vaccination Single vaccination
     */
    static getVaccinationMandatoryType(vaccination) {
        if (!vaccination || !vaccination.is_mandatory) return null;
        return vaccination.is_mandatory;
    }

    constructor(props) {
        super(props);

        const {
            name,
            malaria,
            mandatory,
            polioRegulations,
            MeniMeningitisRegulations,
            allInclusive,
            adventure,
        } = props.countryDetail;

        this.state = {
            name,
            malaria,
            mandatory,
            polioRegulations,
            MeniMeningitisRegulations,
            allInclusive,
            adventure,
        };
    }

    componentDidMount() {
        this.resetModal();
    }

    onVaccinationTitleClickHandler(vaccination) {
        if (!vaccination) return;

        const modalContent = (
            <React.Fragment>
                {vaccination.big.description && <p>{vaccination.big.description}</p>}
                {vaccination.big.infoLink && <p><a href={vaccination.big.infoLink} target="_blank" className="anchor-list__item">Mehr Infos</a></p>}
            </React.Fragment>
        );

        this.setState({
            modalIsOpen: true,
            modalTitle: vaccination.name,
            modalContent,
        });
    }

    onListYellowFeverCountriesClickHandler() {
        const handler = new VaccinationToolYellowFeverHandler({
            contextPath: this.props.contextPath,
        });

        this.setState({
            modalIsOpen: true,
            modalTitle: 'Aktuelle Gelbfieber-Länder',
            modalContent: 'Lade weitere Länder…',
        });

        handler
            .getCountries()
            .then((data) => {
                this.setState({
                    modalContent: data.map(country => country.name).join(', '),
                });
            });
    }

    resetModal() {
        this.setState({
            modalIsOpen: false,
            modalTitle: '',
            modalContent: '',
        });
    }

    render() {
        /*
         * Special Case for yellow fever
         */
        const yellowFeverVaccination = this
            .constructor
            .findVaccinationsForYellowFever(this.state.mandatory);
        const yellowFeverVaccinationMandatory = this
            .constructor
            .getVaccinationMandatoryType(yellowFeverVaccination);

        /*
         * Special Case for polio
         */
        const polioVaccination = this
            .constructor
            .findVaccinationsForPolio(this.state.mandatory);
        const polioVaccinationMandatory = this
            .constructor
            .getVaccinationMandatoryType(polioVaccination);

        /*
         * Special Case for Meningokokken-Meningitis
         */
        const MeniMeningitisVaccination = this
            .constructor
            .findVaccinationsForMeniMeningitis(this.state.mandatory);
        const MeniMeningitisMandatory = this
            .constructor
            .getVaccinationMandatoryType(MeniMeningitisVaccination);

        const showMeniFallbackText = this.state
            .MeniMeningitisRegulations
            .indexOf('Formal Pflichtimpfung') >= 0;

        return (
            <div>
                <h2 className="heading heading--h2 spacing">Impfungen für <strong>{this.state.name}</strong></h2>

                {!!this.state.mandatory.length && (
                    <VaccinationBlock
                        title="Pflichtimpfungen"
                        vaccinations={this.state.mandatory}
                        onVaccinationClick={
                            vaccination => this.onVaccinationTitleClickHandler(vaccination)
                        }
                    >
                        {yellowFeverVaccinationMandatory === 'C' && (
                            <React.Fragment>
                                <p>
                                    Eine Gelbfieber-Impfung ist für Ihr Reiseland nur bedingt
                                    verpflichtend: Reisen Sie aus einem Gelbfieber-Land ein
                                    oder haben über 12 Stunden Transit in einem dieser Länder,
                                    müssen Sie eine Gelbfieber-Impfung nachweisen
                                    (Gelbfieber-Impfbescheinigung).<br />
                                    <button
                                        onClick={
                                            () => this.onListYellowFeverCountriesClickHandler()
                                        }
                                        className="vaccination-tool-result__more-link"
                                    >
                                        Aktuelle Gelbfieber-Länder
                                    </button>
                                </p>
                            </React.Fragment>
                        )}

                        {yellowFeverVaccinationMandatory === 'Y' && (
                            <p>
                                Die Einreise in Ihr Urlaubsland ist nur mit Nachweis
                                über die Gelbfieber-Impfung möglich. Ausnahme:
                                Kinder bis zum Alter von 9 Monaten,
                                benötigen keine Gelbfieber-Impfung.
                            </p>
                        )}

                        {polioVaccinationMandatory === 'Y' && (
                            <React.Fragment>
                                <p>
                                    {this.state.polioRegulations}
                                </p>
                            </React.Fragment>
                        )}

                        {polioVaccinationMandatory === 'C' && (
                            <React.Fragment>
                                <p>
                                    Eine Polio-Impfung ist für Ihr Reiseland
                                    nur bedingt verpflichtend:
                                    {this.state.polioRegulations}
                                </p>
                            </React.Fragment>
                        )}

                        {MeniMeningitisMandatory === 'Y' && (
                            <React.Fragment>
                                {showMeniFallbackText && (
                                    <p>
                                        Bei der Einreise in Ihr Urlaubsland
                                        kann der Nachweis einer
                                        Meningokokken-Impfung von allen
                                        Reisenden verlangt werden.
                                    </p>
                                )}

                                {!showMeniFallbackText && (
                                    <p>
                                        {this.state.MeniMeningitisRegulations}
                                    </p>
                                )}
                            </React.Fragment>
                        )}
                    </VaccinationBlock>
                )}

                <VaccinationBlock
                    title="Empfehlung für alle Reisenden"
                    vaccinations={this.state.allInclusive}
                    onVaccinationClick={
                        vaccination => this.onVaccinationTitleClickHandler(vaccination)
                    }
                >
                    <p>
                        Diese Impfungen sind für Urlaube in Großstädten, Touristengegenden
                        oder Hotelanlagen nach westlichem Standard empfohlen.
                        Planen Sie abenteuerliche Tagesausflüge, kann zusätzlicher
                        Impfschutz notwendig sein.
                    </p>
                </VaccinationBlock>

                <VaccinationBlock
                    title="Empfehlung für Abenteurer"
                    vaccinations={this.state.adventure}
                    onVaccinationClick={
                        vaccination => this.onVaccinationTitleClickHandler(vaccination)
                    }
                >
                    <p>
                        Diese Impfungen sind vor allem für Backpacker
                        und Reisen durch das Landesinnere unter einfachen
                        Bedingungen, wie z.B. Campingreisen, oder bei
                        Langzeitaufenthalten notwendig.
                    </p>
                </VaccinationBlock>

                {this.state.malaria && (
                    <VaccinationBlock title={`Malaria: Risiko in ${this.state.name}`}>
                        <p>
                            {this.constructor.getFirstMalariaParagraph(this.state.malaria)}
                        </p>
                        <p>
                            Eine Impfung gegen Malaria gibt es nicht! Allerdings
                            gibt es Malariamittel zur Vorbeugung (Prophylaxe) oder
                            Notfall-Medikamente (Standby), die bei Erkrankung
                            eingenommen werden können.
                        </p>
                    </VaccinationBlock>
                )}

                <div>* Quelle: STIKO, WHO und Deutsche Gesellschaft für Tropenmedizin (DTG)</div>

                <InfoModal
                    open={this.state.modalIsOpen}
                    title={this.state.modalTitle}
                    text={this.state.modalContent}
                    onClose={() => this.resetModal()}
                />
            </div>
        );
    }
}

export default withContextPath(VaccinationToolResults);



// WEBPACK FOOTER //
// ./src/frontend/apps/VaccinationTool/VaccinationToolResults.jsx